import { QueryClientProvider } from "react-query";
import { RouterProvider } from "react-router";
import ToastContextFC from "./context/toast/ToastContext";
import router from "./router/Route";
import queryClient from "./utils/queryClient";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import UserInformationContextFC from "./context/userInformation/UserInformationContext";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import NavbarLocationContextFC from "./context/navbarLocation/NavbarLocationContext";

const theme = createTheme({
  typography: {
    fontFamily: "Rubik, serif", // Your custom font
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <QueryClientProvider client={queryClient}>
          <NavbarLocationContextFC>
            <UserInformationContextFC>
              <ToastContextFC>
                <RouterProvider router={router} />
              </ToastContextFC>
            </UserInformationContextFC>
          </NavbarLocationContextFC>
        </QueryClientProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
